// removed by extract-text-webpack-plugin
module.exports = {"theme":"#56145a"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 45